import { InjectionToken } from '@angular/core';

export const APP_CONFIG = new InjectionToken<AppConfig>('app.config');

export interface AppConfig {
	availableLanguages: Array<{ code: string; name: string }>;
	showBuyPromt: boolean;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const BaseAppConfig: AppConfig = {
	availableLanguages: [{
		code: 'en',
		name: 'English'
	}, {
		code: 'ar',
		name: 'Arabic'
	}],
	showBuyPromt: false
};
